import {
  FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_REQUEST,
  FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_SUCCESS,
  FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_FAILURE,
  FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_REQUEST,
  FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_SUCCESS,
  FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_FAILURE,
} from '../FirstTimeSetupActionType';

const initialState = {
  serviceAccountCreated: false,
  creating: false,
  success: false,
  error: false,
  skipping: false,
  skipError: false,
};

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_REQUEST:
      return {
        ...state,
        creating: true,
        success: false,
        error: false,
        skipError: false,
      };
    case FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_SUCCESS:
      return {
        ...state,
        creating: false,
        success: true,
      };
    case FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_FAILURE:
      return {
        ...state,
        creating: false,
        error: true,
      };
    case FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_REQUEST:
      return {
        ...state,
        skipping: true,
        success: false,
        error: false,
        skipError: false,
      };
    case FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_SUCCESS:
      return {
        ...state,
        skipping: false,
      };
    case FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_FAILURE:
      return {
        ...state,
        skipping: false,
        skipError: true,
      };
    default:
      return state;
  }
};
